import { Google } from 'reaxl-analytics';

export function dealerRatingClick({
    data = {},
}, option) {
    const { ratingSource, value, count, id } = data;

    Google.sendClickEvent({
        eventElement: 'dealer-rating',
        eventResult: `rating::${ratingSource}::${value}::${count}`,
        eventData: {
            svocId: id?.toString(),
        },
    }, option);

    return {};
}

export function dealerRatingImpressions(metadata = {}, option) {
    const { data = {} } = metadata;
    const { id } = data;
    Google.sendImpressions(metadata, {
        eventElement: 'dealer-rating',
        eventResult: 'rating',
        eventData: {
            svocId: id?.toString(),
        },
    }, option);

    return {};
}
